module.exports = __webpack_public_path__ + "img/Pic_Logo.1e00d29c.png";